import {ref, watchEffect} from "vue";
import {isString} from "@/lib/getVariableType";

export const useFormField = (name, config) => { // todo: test
    /*
         name: form field name
         config: {
             document,         // ref to reactive document
             isRequired: true, // true | false
             defaultValue: '',
             tests: [
                {
                    title: 'should be a valid email address',
                    validator: value => errorMessage,
                }
             ]
     */
    config = config || {}

    const isPristine = ref(true)

    // const checkTests = (tests) => {
    //     tests = tests || []
    //     const {isRequired} = config
    //     if (isRequired && !field.value) inputErrors.value.isRequired = `${name} is required.`
    //
    //     tests.forEach(test => {
    //         const {title, validator} = test
    //         if (!isString(title) || !title.length > 0) throw `useFormField('${name}'): Test title must be a non-empty string.`
    //         if (!isFunction(validator)) throw `useFormField('${name}'): Invalid test validator for '${title}'. Test must be a function returning an errorMessage.`
    //     })
    // }
    //
    // checkTests(config.tests || [])
    const field = ref(config.value ?? config.defaultValue ?? '')

    const document = ref(config.document)
    watchEffect(() => {
        if (config.document?.value) {
            field.value = document.value?.[name]
        }
    })

    const isValid = ref(false)

    const inputErrors = ref(null)
    const error = ref(null)
    const syncValueErrors = () => {
        const {isRequired, tests = []} = config
        const errors = {}

        if (isRequired && !field.value) errors.isRequired = `${name} is required.`

        tests.forEach(({title, validator}) => {
            let errorMessage = validator(field.value)
            if (errorMessage) {
                errors[title] = errorMessage
                // console.log(110, `Failed form field value validator (${title}):`, errorMessage, field.value)
            } else {
                delete errors[title]
            }
        })
        inputErrors.value = errors

        error.value = Object.values(errors)
            .filter(error => !!error)
            .join('\n')
            .trim() || null

        isValid.value = !Object.values(errors)
            .filter(error => !!error)
            .length
    }
    syncValueErrors()


    const onUpdate = newValue => {
        if (newValue === undefined) throw `useFormField('${name}'): Update value error. value is undefined.`
        if (isString(newValue)) newValue = newValue.trim()

        field.value = newValue
        isPristine.value = false

        syncValueErrors()
    }
    const onReset = () => {
        field.value = config.defaultValue ?? ''
        isPristine.value = true
        syncValueErrors()
    }

    return {
        defaultValue: config.defaultValue,
        error,
        inputErrors,
        field,
        isPristine,
        isValid,
        onUpdate,
        onReset,
    }
}